import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotUpdateInvoiceException extends QuoteException {

}